module.exports = __webpack_public_path__ + "static/img/Jarrod-Witts.b2afce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jarrod-Witts.jpg
// module id = cqmB
// module chunks = 0